// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__84Dip","inner":"Footer_inner__1o7oU"};